export default "__VITE_ASSET__50b1b366__"